const AuthState = {
	LOGGED_OUT: "LOGGED_OUT",
	LOGGING_IN: "LOGGING_IN",
	LOGGING_IN_CHALLENGE: "LOGGING_IN_CHALLENGE",
	LOGGING_OUT: "LOGGING_OUT",
	LOGGED_IN: "LOGGED_IN"
};
export default AuthState;
